import { useMemo, useState } from 'react'
import { getTimeZoneIds, getTimeZoneOptionLabel, searchTimeZoneIds } from '../lib/timezones'

export default function TimezoneSelect({
  value,
  onChange,
  placeholder = 'Search timezone (e.g. PST, Pacific, Los Angeles)',
  className = '',
}: {
  value: string
  onChange: (next: string) => void
  placeholder?: string
  className?: string
}) {
  const [open, setOpen] = useState(false)
  const timezones = useMemo(() => getTimeZoneIds(), [])
  const suggestions = useMemo(() => {
    const query = String(value || '').trim()
    const names = searchTimeZoneIds(timezones, query, 40)
    return names.map((name) => ({ value: name, label: getTimeZoneOptionLabel(name) }))
  }, [timezones, value])

  return (
    <div className={`relative ${className}`}>
      <input
        value={value}
        onFocus={() => setOpen(true)}
        onBlur={() => window.setTimeout(() => setOpen(false), 100)}
        onChange={(e) => {
          setOpen(true)
          onChange(e.target.value)
        }}
        placeholder={placeholder}
        className="w-full rounded-lg border border-white/10 bg-black/30 px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-brand"
      />
      {open ? (
        <div className="absolute z-20 mt-1 max-h-56 w-full overflow-y-auto rounded-lg border border-white/10 bg-black shadow-2xl">
          {suggestions.length === 0 ? (
            <div className="px-3 py-2 text-xs text-white/60">No matching timezones</div>
          ) : (
            suggestions.map((row) => (
              <button
                key={row.value}
                type="button"
                onMouseDown={(e) => {
                  e.preventDefault()
                  onChange(row.value)
                  setOpen(false)
                }}
                className="block w-full px-3 py-2 text-left hover:bg-white/10"
              >
                <div className="text-xs text-white/90">{row.label}</div>
                {row.label !== row.value ? <div className="text-[11px] text-white/55">{row.value}</div> : null}
              </button>
            ))
          )}
        </div>
      ) : null}
    </div>
  )
}

